/**
 * Home Routes
 */
export default [
    {
        path: '/',
        name: 'home',
        component: () => import('../../pages/home/IndexPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: false,
            title: 'Home',
        },
    },
    {
        path: '/home/termsofservice',
        name: 'termsOfService',
        component: () => import('../../pages/home/TermsOfServicePage.vue'),
        meta: {
            layout: 'blank',
            requiresAuth: false,
            title: 'Terms of Service',
        },
    },
    {
        // 홈 "새 소식" 더보기 — 홈은 최근 3건만 보여준다.
        path: '/notices',
        name: 'notices',
        component: () => import('../../pages/notices/IndexPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            title: 'Notices',
        },
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('../../pages/home/FaqPage.vue'),
        meta: {
            layout: 'default',
            requiresAuth: false,
            title: 'FAQ',
        },
    },
];
